import * as React from 'react';
import IconButton from '@sdk/components/ui/buttons/IconButton';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

import PlusGraySvg from '../../assets/svg/Misc/plus-gray.svg';

const iconMap = {
  plusGray: <PlusGraySvg />,
};

export type Props = {
  onClick: () => Promise<string>;
  disabled?: boolean;
  inactive?: boolean;
  fontWeight?: 'bold' | 'semiBold';
  buttonType?: ButtonType;
  label: string;
  justifyContent?: string;
  iconLeft?: string;
  iconRight?: string;
};

const IconButtonWrapper: React.FC<React.PropsWithChildren<Props>> = ({
  label,
  iconRight,
  iconLeft,
  ...props
}) => (
  <IconButton iconLeft={iconMap[iconLeft]} iconRight={iconMap[iconRight]} {...props}>
    {label}
  </IconButton>
);

export default {
  ReactComponent: IconButtonWrapper,
  bindings: {
    onClick: '&',
    disabled: '<?',
    inactive: '<?',
    fontWeight: '@?',
    buttonType: '@?',
    label: '@',
    justifyContent: '@?',
    iconLeft: '@?',
    iconRight: '@?',
  },
};
